import React, { useEffect, useState } from 'react'
import { API } from '../../../api/Api';

const StyleTypeDropDown = ({ onStyleSelect, className, value }) => {
    const [styleType, setStyleType] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchGrain = async () => {
        // const url = API_ROUTES.GET_ACTIVITY_LIST;
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizermasterlist';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { type: "styletype" };

        try {
            const token = localStorage.getItem('token');
            const response = await API(url, requestBody, token);

            if (response) {
                setStyleType(response.Data);
            }
        } catch (error) {
            setError('Error fetching Grain');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGrain();
    }, []);

    if (loading) return <p className='text-sm my-4 mx-2'>Loading Style Type...</p>;
    if (error) return <p>{error}</p>;
    return (
        <div className="mb-">
            <select
                value={value}
                onChange={(e) => onStyleSelect(e.target.value)}
                className={`${className} block border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300`}
            // className="block w-full py-3 px-4 text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"

            >
                <option value="" disabled>Select Style Type</option>
                {styleType.map((styleType) => (
                    <option key={styleType.id} value={styleType.id} className=''>
                        {styleType.name}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default StyleTypeDropDown